import state from './moduleStepState.js'
import mutations from './moduleStepMutations.js'
import actions from './moduleStepActions.js'
import getters from './moduleStepGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}